import {
  CheckCircle,
  FileText,
  User,
  Home,
  CreditCard,
  File,
  AlertCircle,
  Bell,
  PenLine,
  Shield,
  Receipt,
  Building2,
  Calendar,
  Clock,
  Mail,
  Phone,
  Settings,
  Trash2,
  Edit,
  Plus,
  Minus,
  X,
  Check,
  Info,
  HelpCircle,
  Lock,
  Unlock,
  Eye,
  EyeOff,
  Download,
  Upload,
  Link,
  Unlink,
  RefreshCw,
  RotateCcw,
  Send,
  Archive,
  Folder,
  FolderOpen,
  FileCheck,
  FilePlus,
  FileMinus,
  FileX,
  UserPlus,
  UserMinus,
  UserCheck,
  UserX,
  Users,
  Briefcase,
  DollarSign,
  Euro,
  Percent,
  TrendingUp,
  TrendingDown,
  BarChart,
  PieChart,
  Activity,
  Heart,
  Star,
  Flag,
  Bookmark,
  Tag,
  Hash,
  AtSign,
  MessageSquare,
  MessageCircle,
  Clipboard,
  ClipboardCheck,
  ClipboardList,
  List,
  ListChecks,
  CheckSquare,
  Square,
  Circle,
  AlertTriangle,
  XCircle,
  MinusCircle,
  PlusCircle,
  ArrowRight,
  ArrowLeft,
  ArrowUp,
  ArrowDown,
  ChevronRight,
  ChevronLeft,
  ChevronUp,
  ChevronDown,
  ExternalLink,
  Copy,
  Scissors,
  Paperclip,
  Image,
  Camera,
  Video,
  Mic,
  Volume2,
  VolumeX,
  Play,
  Pause,
  Square as Stop,
  SkipForward,
  SkipBack,
  Repeat,
  Shuffle,
  Zap,
  Battery,
  Wifi,
  Globe,
  Map,
  MapPin,
  Navigation,
  Compass,
  Sun,
  Moon,
  Cloud,
  CloudRain,
  Umbrella,
  Thermometer,
  Wind,
  Droplet,
  Flame,
  Snowflake,
  Loader,
  Search,
  ZoomIn,
  ZoomOut,
  Filter,
  SlidersHorizontal,
  Maximize,
  Minimize,
  Move,
  Grip,
  MoreHorizontal,
  MoreVertical,
  Menu,
  Grid,
  Layout,
  Columns,
  Rows,
  Table,
  Database,
  Server,
  HardDrive,
  Cpu,
  Monitor,
  Smartphone,
  Tablet,
  Watch,
  Tv,
  Speaker,
  Headphones,
  Printer,
  Save,
  Power,
  LogIn,
  LogOut,
  Key,
  Fingerprint,
  CreditCard as CardIcon,
  Wallet,
  ShoppingCart,
  ShoppingBag,
  Package,
  Gift,
  Truck,
  Car,
  Bus,
  Train,
  Plane,
  Anchor,
  Rocket,
  Award,
  Trophy,
  Medal,
  Crown,
  Gem,
  Coffee,
  Utensils,
  Wine,
  Beer,
  Cake,
  Cookie,
  Apple,
  Carrot,
  Leaf,
  Trees as Tree,
  Flower,
  Bug,
  Cat,
  Dog,
  Bird,
  Fish,
  Rabbit,
  Turtle,
  type LucideIcon
} from 'lucide-react';

/**
 * Mapping of icon keys to Lucide React icon components.
 * The backend should send one of these keys in the `iconKey` field.
 */
export const iconMapping: Record<string, LucideIcon> = {
  // Status & Validation
  CheckCircle,
  AlertCircle,
  AlertTriangle,
  XCircle,
  MinusCircle,
  PlusCircle,
  Info,
  HelpCircle,
  Bell,

  // Files & Documents
  File,
  FileText,
  FileCheck,
  FilePlus,
  FileMinus,
  FileX,
  Folder,
  FolderOpen,
  Archive,
  Clipboard,
  ClipboardCheck,
  ClipboardList,

  // Users & People
  User,
  UserPlus,
  UserMinus,
  UserCheck,
  UserX,
  Users,

  // Buildings & Places
  Home,
  Building2,
  MapPin,
  Map,
  Globe,

  // Finance & Business
  CreditCard,
  Wallet,
  DollarSign,
  Euro,
  Percent,
  Receipt,
  Briefcase,
  TrendingUp,
  TrendingDown,
  BarChart,
  PieChart,

  // Actions
  Edit,
  PenLine,
  Trash2,
  Plus,
  Minus,
  Check,
  X,
  Save,
  Copy,
  Scissors,
  Paperclip,
  Link,
  Unlink,
  Download,
  Upload,
  Send,
  RefreshCw,
  RotateCcw,
  Search,
  Filter,

  // Security & Privacy
  Shield,
  Lock,
  Unlock,
  Key,
  Fingerprint,
  Eye,
  EyeOff,

  // Communication
  Mail,
  Phone,
  MessageSquare,
  MessageCircle,
  AtSign,

  // Time & Calendar
  Calendar,
  Clock,

  // Settings & Config
  Settings,
  SlidersHorizontal,

  // Navigation
  ArrowRight,
  ArrowLeft,
  ArrowUp,
  ArrowDown,
  ChevronRight,
  ChevronLeft,
  ChevronUp,
  ChevronDown,
  ExternalLink,
  LogIn,
  LogOut,

  // Lists & Plateforme
  List,
  ListChecks,
  CheckSquare,
  Square,
  Circle,
  Tag,
  Hash,
  Bookmark,
  Flag,
  Star,

  // Media
  Image,
  Camera,
  Video,
  Mic,
  Volume2,
  VolumeX,
  Play,
  Pause,

  // Shopping & Commerce
  ShoppingCart,
  ShoppingBag,
  Package,
  Gift,

  // Transport
  Truck,
  Car,
  Bus,
  Train,
  Plane,

  // Misc
  Activity,
  Heart,
  Zap,
  Loader,
  Award,
  Trophy,
  Crown,
  Gem,
  Coffee
};

/**
 * Get a Lucide icon component by its key.
 * Returns a fallback icon (CheckCircle) if the key is not found.
 *
 * @param iconKey - The key of the icon (e.g., "FileText", "User", "CheckCircle")
 * @param fallback - Optional fallback icon to use if key is not found
 * @returns The Lucide icon component
 */
export const getIconByKey = (
  iconKey: string | undefined | null,
  fallback: LucideIcon = CheckCircle
): LucideIcon => {
  if (!iconKey) {
    return fallback;
  }

  return iconMapping[iconKey] || fallback;
};

/**
 * Check if an icon key is valid (exists in the mapping).
 */
export const isValidIconKey = (iconKey: string): boolean => {
  return iconKey in iconMapping;
};

/**
 * Get all available icon keys.
 */
export const getAvailableIconKeys = (): string[] => {
  return Object.keys(iconMapping);
};
